import React from 'react';

export default function Knowledge(props) {
  const {color} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.133"
      height="30.787"
      viewBox="0 0 26.133 30.787"
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        data-name="Group 133"
        transform="translate(.5 .5)"
      >
        <path
          d="M15.824 26.995H9.309v-5a1.867 1.867 0 00-.983-1.633 8.84 8.84 0 01-4.591-8.171 8.934 8.934 0 018.568-8.429 8.844 8.844 0 014.514 16.6A1.874 1.874 0 0015.828 22z"
          data-name="Path 3964"
        ></path>
        <path
          d="M12.568 29.788h0a2.327 2.327 0 01-2.327-2.327v-.465h4.654v.465a2.327 2.327 0 01-2.327 2.327z"
          data-name="Path 3965"
        ></path>
        <path d="M0 0L6.516 0" data-name="Line 62" transform="translate(9.308 22.34)"></path>
        <path
          d="M11.17 22.34v-10.7a1.4 1.4 0 10-1.4 1.4h5.585a1.4 1.4 0 10-1.4-1.4v10.7"
          data-name="Path 3966"
        ></path>
        <path d="M0 0L6.516 0" data-name="Line 63" transform="translate(9.308 24.667)"></path>
        <path d="M0 0L0 1.862" data-name="Line 64" transform="translate(12.566)"></path>
        <path d="M0 0L0.931 1.612" data-name="Line 65" transform="translate(6.283 1.684)"></path>
        <path d="M0 0L1.612 0.931" data-name="Line 66" transform="translate(1.684 6.283)"></path>
        <path d="M0 0L1.862 0" data-name="Line 67" transform="translate(0 12.566)"></path>
        <path d="M0 0.931L1.612 0" data-name="Line 68" transform="translate(1.684 17.919)"></path>
        <path d="M1.612 0.931L0 0" data-name="Line 69" transform="translate(21.837 17.919)"></path>
        <path d="M1.862 0L0 0" data-name="Line 70" transform="translate(23.271 12.566)"></path>
        <path d="M1.612 0L0 0.931" data-name="Line 71" transform="translate(21.837 6.283)"></path>
        <path d="M0.931 0L0 1.612" data-name="Line 72" transform="translate(17.919 1.684)"></path>
      </g>
    </svg>
  );
}
